import { Badges, H5, LI } from "../../../../AbstractElements";
import SvgIcon from "../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { Messages } from "../../../../Utils/Constants";
import MessageBox from "./MessageBox";

const HeaderMessage = () => {
  return (
    <LI className="onhover-dropdown">
      <div className="notification-box">
        <SvgIcon iconId={'header-message'} />
        <Badges pill color="secondary">3 </Badges>
      </div>
      <div className="onhover-show-div notification-dropdown">
        <H5 className="f-18 f-w-600 mb-0 dropdown-title">{Messages} </H5>
        <MessageBox />
      </div>
    </LI>
  );
};

export default HeaderMessage;
